import {useRouter} from 'next/router';
import {useEffect} from 'react';
import {IProduct} from 'types';
import {isObjEmpty} from 'utils/helpers';

interface Params {
  products?: IProduct[];
  onProductSelect: (product: IProduct) => void;
}

export const useURLSpecificParams = ({products, onProductSelect}: Params) => {
  const {push, asPath} = useRouter();

  useEffect(() => {
    const paramsStringArray = asPath.split('#');

    if (!paramsStringArray[1] || !products?.length) return;
    const splittedParams = paramsStringArray[1].split('-');
    // const splittedParams = paramsStringArray[paramsStringArray.length - 1].split('-');
    const productParamIndex = splittedParams.indexOf('product');
    const productIdParam = productParamIndex !== -1 ? splittedParams[productParamIndex + 1] : undefined;

    if (productIdParam && products) {
      const foundProduct = products.find((product) => product.id === Number(productIdParam));

      if (foundProduct) {
        onProductSelect(foundProduct);
        return;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products, asPath]);

  const changeURLRelativePath = (params?: Record<string, number>) => {
    if (isObjEmpty(params) || !params) {
      push(asPath.split('#')[0], undefined, {
        shallow: true,
        scroll: false,
      });
      return;
    }

    let path = '#';

    const {productId} = params ?? {};

    if (productId) {
      path += `product-${productId}`;
    }

    push(path, undefined, {
      shallow: true,
      scroll: false,
    }).then(() => {
      push(path, undefined, {
        shallow: true,
      });
    });
  };

  return {
    changeURLRelativePath,
  };
};
